export const getLocationName = async (coords: number[]) => {
  const c = new GetCurrentLocation(coords);
  await c.get();
  return c.data.display_name;
};

class GetCurrentLocation {
  data: any;
  coords: number[];
  constructor(coords: number[]) {
    this.data = undefined;
    this.coords = coords;
  }
  get = async () => {
    const url =
      "https://nominatim.openstreetmap.org/reverse?format=jsonv2" +
      "&lat=" +
      this.coords[0] +
      "&lon=" +
      this.coords[1];

    await fetch(url, {
      method: "GET",
      mode: "cors",
      headers: {
        "Access-Control-Allow-Origin": "https://o2cj2q.csb.app",
      },
    })
      .then((response) => response.json())
      .then((d) => (this.data = d));
  };
}
